import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import { sendData } from "../../analytics/sendData";
import { config } from "./../../constants/domainConfig";
import { FormattedMessage } from "react-intl";
import { isGamiclub } from "../../constants/isGamiclub";
import { isGamelords } from "../../constants/productCondition";
import { isTheGamingClubs } from "../../constants/isTheGamingClubs";

class Terms extends Component {
  componentDidMount() {
    sendData("", "", "", "viewed", { page: "terms-&-conditions" });
    window.scrollTo(0, 0);
  }

  render() {
    if (config.subDomain === "rs") {
      return (
        <section className="terms">
          <Container fluid>
            <Row>
              <Col xs="12">
                <div className="terms-title-wrap">
                  <h2 className="terms-section-title">Услови коришћења</h2>
                  <p
                    className="terms-para"
                    style={{ textAlign: "center", fontSize: "14px" }}
                  >
                    Посетилац - представља особу која посећује веб локацију која
                    рекламира услугу или другу страницу за оглашавање (штампа,
                    ТВ и радио).
                  </p>
                </div>
              </Col>
            </Row>
            <Row className="no-gutters">
              <Col xs="12" className="terms-list">
                <p className="terms-para-head">Ток претплате:</p>
                <p className="terms-para-list">
                  - крајњи корисник треба да унесе свој број мобилног телефона
                  на одредишној страници
                </p>
                <p className="terms-para-list">
                  - крајњи корисник ће затим добити јединствени једнократни пин
                </p>
                <p className="terms-para-list">
                  - након што унесе једнократни пин на одредишну страницу,
                  корисник се пријављује на нашу услугу
                </p>
                <p className="terms-para-list">
                  - крајњи корисник ће добити поруку добродошлице и одмах затим
                  поруку ка садржају, како би могао да ужива у нашем производу
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">1. ИЗЈАВА О ПРИВАТНОСТИ</h6>
                <p className="terms-para">
                  Заштита личних података корисника за нас је важна. За понуђене
                  услуге прикупљамо, обрађујемо или користимо личне податке
                  корисника, као што је описано у наредним чланцима. Електронски
                  подаци су подаци корисника који услугу активирају оглашавањем
                  на Интернету или активирањем путем Интернета, а то су ИП
                  адреса корисника, корисник е-поште, оперативни систем,
                  прегледане странице у оквиру оглашавања услуге.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">2. КОРИСНИ ПОСЈЕТНИЦИ</h6>
                <p className="terms-para">
                  Подаци које посетилац (особа која није активирала услугу)
                  произвољно оставља на рекламним локацијама, укључујући
                  телефонски број, адресу е-поште и друге личне и електронске
                  податке, подаци су за које пружалац услуге има право да
                  користи у оквиру својих пројеката. Посетилац се такође слаже
                  да пружалац услуга може користити своје бројеве мобилних
                  телефона у својим маркетиншким активностима.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">3. Приступ услузи</h6>
                <p className="terms-para-head">3.1 </p>
                <p className="terms-para">
                  Организатор услуге Организатор и добављач услуга је компанија
                  Интер Sam Media BV. Коришћењем ове услуге корисник потврђује
                  да је прочитао и разумео услове коришћења услуге и у
                  потпуности се са њима слаже.
                </p>
                <p className="terms-para-head">3.2. Опис услуге</p>
                <p className="terms-para">
                  Сервис могу да користе корисници мобилних оператера МТС,
                  Yеттел, A1 који имају 18 или више година. слуга је забавна и
                  пружа портал са најбољим хтмл5 играма, могућношћу скидања на
                  андроид уређајима те забавни видео садржај, доступних на вашем
                  мобилном уређају, са неограниченим приступом у току ваше
                  онлајн претплате..
                </p>
                <p className="terms-para-head">
                  3.3. Опис функционисања услуге
                </p>
                <p className="terms-para">
                  Да би учествовао у услузи, корисник прихвата услове услуге и
                  претплаћује се на услугу.
                </p>
                <p className="terms-para-head">3.4. Плаћање</p>
                <p className="terms-para">
                  услуга Услуга се плаћа. Плаћање се врши преко мобилног
                  оператера. Корисницима свих мобилних провајдера наплаћује се
                  свака послата порука осим системске поруке. Пружалац услуга
                  има право промене цена својих услуга, али је дужан да о томе
                  обавести кориснике на свим местима где су постављени услови и
                  упутства за коришћење услуга. Ако провајдер сервиса промени
                  цену услуге током периода услуге, корисник остаје корисник
                  услуге док се не одјави из услуге.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">4. ОПШТА ПРАВИЛА</h6>
                <p className="terms-para-head">4.1. Опис и сврха услуге</p>
                <p className="terms-para">
                  Интернет, штампа, ТВ и радио медији место су за оглашавање
                  забавних услуга путем мобилних телефона путем коришћења СМС
                  порука. Сврха услуге је искључиво у забаву. Пружалац услуга не
                  утиче на кориснике и операторе, а нарочито на СМС комуникацију
                  тамо где се не може потврдити да су информације које размењују
                  корисници и оператери тачне.
                </p>
                <p className="terms-para-head">
                  4.2. Доступност услуге Добављач услуга
                </p>
                <p className="terms-para">
                  покушава максимално повећати расположивост услуге. Због
                  техничких карактеристика интернетске везе и мобилне
                  телефоније, на које добављач услуга не утјече, може доћи до
                  повремених прекида у преносу података - раду услуге. Провајдер
                  сервиса не може гарантовати доступност и доступност услуге.
                </p>
                <p className="terms-para-head">
                  4.3. Технички услови за коришћење услуге
                </p>
                <p className="terms-para">
                  Корисник мора да осигура одржавање и подешавања свог мобилног
                  телефона. У овом случају, пружалац услуга није дужан да пружа
                  техничку подршку. Да би користио услугу, корисник мора
                  користити функционални мобилни телефон и имати ваљану везу
                  (сигнал) на свом мобилном телефону. Без ових услова употреба
                  услуге није могућа. Корисник је искључиво одговоран за пружање
                  техничких услова. Пружалац услуге није одговоран ако корисник
                  не може да користи услугу због ограничења свог провајдера.
                </p>
                <p className="terms-para-head">
                  4.4. Трошкови коришћења услуге Коришћењем
                </p>
                <p className="terms-para">
                  услуге, корисник пристаје на настале трошкове јер је
                  информисан о цени услуге у складу са правилима које прописују
                  закон и мобилни провајдери. С обзиром на то да су трошкови
                  исказани на сајтовима за оглашавање, као и у условима и
                  условима коришћења, корисник прихвата обавезу да нема право да
                  захтева настале трошкове, као и да надокнади трошкове ако није
                  добио одговор на поруку.
                </p>
                <p className="terms-para-head">4.5. Промена услова коришћења</p>
                <p className="terms-para">
                  Пружалац услуге задржава право да промени услове уговора у
                  било ком тренутку у будућности. Након промена услова коришћења
                  услуге, ако је корисник претходно пристао на услове, а након
                  што промена није, он се може одјавити у складу са
                  функционисањем услуге. Пружалац услуга није дужан да
                  обавештава кориснике о промени услова.
                </p>
                <p className="terms-para-head">
                  4.6. Осигурање / накнада гаранције
                </p>
                <p className="terms-para">
                  Компанија, њени директори, службеници, запослени, добављачи и
                  агенти се одричу сваке одговорности за било какву штету
                  насталу употребом Услуга. Изричито разумете и пристајете да
                  Услуге пружате на начин "какав јесте" и "како је доступан" без
                  икаквих гаранција. Стране добављача изричито се одричу у
                  највећој мери допуштеној законом свим гаранцијама, било
                  изричитим или имплицираним, одређеним законом или на неки
                  други начин, у вези са услугама, укључујући, без ограничења,
                  подразумеване услове продаје, власништва и продаје робе и
                  имовине, као и наменску функцију и кршење ауторских права.
                  Стране у уговору се одричу сваке гаранције у погледу
                  сигурности, поузданости, благовремености и перформанси услуга.
                  Уговорне стране не гарантују да ће Услуге испунити ваше
                  захтеве или да ће услу вета или информација, било да су усмене
                  или писмене, добијене од нас или путем наших услуга, неће се
                  створити гаранција која није овде изричито наведена. Не можете
                  се ослонити на такве информације или савете. Разумете и
                  пристајете на преузимање и / или коришћење Услуга, садржаја,
                  софтвера и веб локација на сопствени ризик и ризик и да ћете
                  бити једини одговорни за било какво оштећење рачунарског
                  система, мобилног телефона или губитак података који су
                  последица. коришћење услуга. Осим у надлежностима у којима су
                  ове одредбе ограничене, слажете се да је целокупна одговорност
                  Компаније према вама или било којој трећој страни, као и за
                  ваш или ексклузивни лек било које треће стране, законски, у
                  капиталу или на други начин у вези са услугама пруженим овим
                  споразумом и / или било каквим кршењем овог споразума,
                  ограничен је искључиво на износ који сте платили за такве
                  услуге током трајања овог уговора. Осим у јурисдикцијама у
                  којима су такве одредбе ограничене, стране уговорнице које су
                  стицале неће бити одговорне за било какву директну,
                  индиректну, случајну, посебну, узорну, кривичну, трећу или
                  последичну штету (укључујући штету због губитка пословне
                  добити, прекида пословања, губитка пословних информација и
                  слично) проистекле из ваше употребе, злоупотребе или
                  немогућности коришћења Услуга, Садржаја, Софтвера и Веб
                  локације, чак и ако је Компанија обавештена о могућности такве
                  штете, у мери у којој држава не дозвољава искључење или
                  ограничење одговорности како је наведено у овом документу. ,
                  одговорност компаније је ограничена на ниво дозвољен законом у
                  тој земљи. Сагласни сте да заштитите Компанију и њене
                  родитеље, чланове, подружнице, подружнице, пружаоце услуга,
                  предузетнике, агенте, даваоце лиценце, службенике, директоре,
                  акционаре и запослене од губитка, одговорности, захтева, тужбе
                  или захтева, укључујући разумне адвокатске накнаде, направљене
                  од било које треће стране која произилази из или у вези са (а)
                  вашом употребом Услуга и (б) кршењем од вас или ваших
                  представника и гаранцијама утврђеним у овим Условима. Платит
                  ћете и све трошкове, одштету и трошкове одштете, укључујући
                  без ограничења, разумне одветничке накнаде и трошкове
                  додијељене за плаћање или на које је Компанија накнађена у
                  вези с било којом таквом тужбом, парницом, поступком,
                  потраживањем или други поступак.
                </p>
              </Col>
              <Col xs="12" className="terms-list">
                <h6 className="terms-title">5. ПРИВАТНОСТ</h6>
                <p className="terms-para-head">
                  5.1. Изјава о заштити приватности
                </p>
                <p className="terms-para">
                  Заштита личних података корисника за нас је важна. Све
                  информације које прикупљамо остављају кориснику произвољно и
                  не морају их остављати.
                </p>
                <p className="terms-para-head">5.2.</p>
                <p className="terms-para">
                  Корисничке информације о услугама {"<бр>"} За потребе
                  функционисања услуге потребан нам је број мобилног телефона
                  корисника да бисмо омогућили СМС поруке. Подаци који се
                  размењују у оквиру услуге све су личне и опште информације
                  које корисник размењује у сервису слањем смс порука. У оквиру
                  важећег законодавства, можемо истраживати корисничке податке у
                  рекламне сврхе, истраживање тржишта, за побољшање наших услуга
                  и за промоцију других услуга које пружа пружалац услуга.
                </p>
                <p className="terms-para-head">5.3.</p>
                <p className="terms-para">
                  Пренос података посетилаца и корисника и снимање у интерном
                  систему у статистичке сврхе Размена података у услузи
                  остварује се путем СМС порука, као и позивима фиксног или
                  мобилног провајдера. Размена позива односи се искључиво на
                  захтев корисника да се одјави, као и на пружање техничке
                  подршке за активирање или одјаву претплате на услугу (али не и
                  информације о кориснику, провајдеру услуге итд.).
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      );
    } else
      return (
        <section className="terms">
          <Container fluid>
            <Row>
              <Col xs="12">
                <div className="terms-title-wrap">
                  <h2 className="terms-section-title">
                    <FormattedMessage
                      id="terms-condition-title"
                      defaultMessage="Terms and Conditions"
                    />
                  </h2>
                </div>
              </Col>
            </Row>
            <Row className="no-gutters">
              {config.subDomain === "my" && (isGamiclub || isGamelords) && (
                <Col xs="12" className="terms-list">
                  <h6 className="terms-title">Owner and Data Controller</h6>
                  <p className="terms-para">
                    <strong>Owner and Data Controller Name</strong>: Sam Media
                    Sdn Bhd
                  </p>
                  <p className="terms-para">
                    <strong>Address:</strong> Suite 2, Level 11, Menara Ilham,
                    NO. 8 Jln Binjai, 50450 KL
                  </p>
                  <p className="terms-para">
                    <strong>Owner contact email:</strong> mycs@content-clubs.com
                  </p>
                </Col>
              )}
              {config.subDomain === 'lt' && isTheGamingClubs &&
              <Col xs="12" className="terms-list">
                  <p className="terms-para">
                    Noteikumi un Nosacījumi
                  </p>
                  <p className="terms-para">
                    NAUDOJIMOSI SĄLYGOS
                  </p>
                  <p className="terms-para">
                   „Gamingclub“ – tai aukščiausios kokybės SMS paslauga, prieinama Telia, „Bitės“ ir „Tele2“ GSM tinklo naudotojams.
                  </p>
                  <p className="terms-para">
                   Šią paslaugą teikia „Sam Media“ (Prizeflix B.V. pagrindinė įmonė), Van Diemenstraat 356, 1013CR - Amsterdamas, Olandija.
                  </p>
                  <p className="terms-para">
                    Kai patvirtinate paslaugą, nukreipimo puslapyje įvesdami unikalų PIN numerį arba raktažodį siųsdami SMS žinute, sutinkate su paslaugos naudojimosi sąlygomis ir prisijungiate prie „Gamingclub“ paslaugos. Gausite unikalią nuorodą, per kurią bus galima pasiekti paslaugą. „Telia“ ir „Bitė“ vartotojams: „Bitė“ vartotojams: kiekvieną savaitę būsite apmokestinti 3,9 EUR, o prenumerata bus automatiškai atnaujinta. „Tele 2“ ir „Telia“ vartotojams: būsite apmokestinti 7 EUR už pranešimą ir galėsite naudotis paslauga dvi savaites.
                  </p>
                  <p className="terms-para">
                    Šie mokesčiai bus mokami iš jūsų išankstinio mokėjimo balanso prenumeratos pradžioje ir vėliau kas savaitę arba bus pridėti prie jūsų mėnesinės mobiliojo telefono sąskaitos už šį telefoną. Tekstinių pranešimų siuntimo mokestis taikomas pagal standartinius operatoriaus tarifus. Pagal jūsų planą gali būti taikomi operatoriaus duomenų mokesčiai.
                  </p>
                  <p className="terms-para">
                    Paslaugos galite atsisakyti siųsdami SMS žinutę STOP GAMING numeriu 1335.
                  </p>
                  <p className="terms-para">
                    Paslaugos prenumeratorius privalo būti mobiliojo telefono savininkas arba turi gauti atitinkamą savininko leidimą dar prieš prisijungiant prie paslaugos. Prie paslaugos jungtis norintys vaikai iki 18 metų privalo gauti tėvų arba globėjų sutikimą.
                  </p>
                  <p className="terms-para">
                    Nei vienas iš išvardytų produktų ar perpardavėjų jokiu būdu nėra susijęs su „Gamingclub“, jis neremia bei papildomai neskatina naudotis „Gamingclub“.
                  </p>
                   <h6 className="terms-title">Galutinės sąlygos</h6>
                  <p className="terms-para">
                    Galutinės sąlygos
                  </p>
                </Col> 
              }
              <Col xs="12" className="terms-list">
                    <h6 className="terms-title">
                      <FormattedMessage
                        id="gen-terms-condition-title"
                        defaultMessage="General Terms And Conditions And Privacy Policy."
                      />
                    </h6>
                    <p className="terms-para">
                      <FormattedMessage
                        id="gen-terms-condition-desc"
                        defaultMessage="The following General Terms and Conditions are applicable to the products and services supplied via WAP, SMS, GPRS and 3G by Sam Media Ltd., or enterprises affiliated to it, (hereinafter to be referred to as “the Provider”). The Provider is permitted to amend these General Terms and Conditions from time to time without notice. Apart from the General Terms and Conditions, any applicable and publicized rules, promotional conditions, guidelines and provisions pertaining to the services also apply to you and the Provider upon the use of the Services (as defined herein) of the Provider. All those guidelines, rules, promotional conditions and provisions will be considered an inextricable part of these General Terms and Conditions. By availing yourself to use the Services of the Provider, you agree to be bound by these General Terms and Conditions and the guidelines, rules and promotional conditions."
                      />
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">
                      <FormattedMessage
                        id="provider-terms-condition-title"
                        defaultMessage="Description Of The Provider."
                      />
                    </h6>
                    <p className="terms-para">
                      <FormattedMessage
                        id="provider-terms-condition-desc"
                        defaultMessage="By means of WAP, SMS, GPRS and 3G services, the Provider supplies its user’s access to a network of on-line sources, including on-line games, text messages, rich content and on-line information material which may be downloaded onto mobile telephone or whatsoever devices (“Services”). The General Terms and Conditions are at all times applicable to all new facilities including facilities which the Provider may implement as part of the Provider’s expansion, extension or improvement of the present Services, including any extension to new functions added by the Provider."
                      />
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">
                      <FormattedMessage
                        id="availability-terms-condition-title"
                        defaultMessage="Availability."
                      />
                    </h6>
                    <p className="terms-para">
                      <FormattedMessage
                        id="availability-terms-condition-desc"
                        defaultMessage="The Service is supplied as is (at the stage of development it happens to be in) and the Provider accepts no liability nor does it issue any guarantees or warranty in the event that personal configurations, information or messages are not saved, or not saved in due time, or if they are deleted or incorrectly delivered. In order to subscribe to the Service, you are required to have access to the Internet and/or a mobile communications subscription and pay any service fees associated with such access. You are required to pay all expenses incurred in creating such access. You are also responsible for seeing to the connection of any necessary equipment, including any mobile telephone or personal computer or whatever devices that may be necessary needed and are in working order and suitable for use in connection with the Service."
                      />
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">
                      <FormattedMessage
                        id="payment-terms-condition-title"
                        defaultMessage="Payment."
                      />
                    </h6>
                    <p className="terms-para">
                      <FormattedMessage
                        id="payment-terms-condition-desc"
                        defaultMessage="You have access to our on-line services free of charge. With regards to the Services and the use of it, you shall pay the amount corresponding to the applicable rates of the Provider in force at that time and according to the rates charged by your mobile operator. The charges shall be invoiced to you via your mobile operator through the mobile bill you receive from the mobile operator of your network. You pay the Provider all national and local or other taxes, including but not restricted to VAT, any taxes or levies imposed in lieu thereof, which taxes are based on the costs due to the use of the Services, regardless of whether those taxes are levied either now or in the future by European, national or local authorities or by any other body or bodies authorized to levy taxes. The Provider reserves the right to change the rates for the Service by posting details of such changes on its website."
                      />
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">
                      <FormattedMessage
                        id="obligation-terms-condition-title"
                        defaultMessage="Registration Obligation."
                      />
                    </h6>
                    <p className="terms-para">
                      <FormattedMessage
                        id="obligation-terms-condition-desc"
                        defaultMessage="In order to warrant safe and secure use of the Service, you guarantee the following, in addition to paying the applicable charges: (a) your personal information (hereinafter to be referred to as the “Registered Information”) provided on the registration form is correct, true, accurate and complete and (b) you agree to ensure that the Registered Information is at all times correct, up to date, true, accurate and complete. If the Provider has a reasonable suspicion that the Registered Information does not reflect a true state of affairs, or is not accurate or complete, then the Provider is entitled to suspend or terminate your account and to withhold both current and future use of the Service, or any component of it. You yourself are responsible for maintaining the secrecy of any passwords and/or accounts issued to you by the Provider, and you are fully liable for all actions carried out involving the use of your password or account. You undertake at the end of each session to close your account (by closing your browser) and to contact the Provider if you notice or suspect that unauthorized use has been made of your password or account, or that security or protection is no longer guaranteed for any other reason. The Provider cannot and will not be liable for any damage arising from your failure to observe the stipulations of this article."
                      />
                    </p>
                  </Col>
                  <Col xs="12" className="terms-list">
                    <h6 className="terms-title">
                      <FormattedMessage
                        id="ownership-terms-condition-title"
                        defaultMessage="Ownership Rights Of The Provider."
                      />
                    </h6>
                    <p className="terms-para">
                      <FormattedMessage
                        id="ownership-terms-condition-desc"
                        defaultMessage="The following General Terms and Conditions are applicable to the products and services supplied via WAP, SMS, GPRS and 3G by Sam Media Ltd., or enterprises affiliated to it, (hereinafter to be referred to as “the Provider”). The Provider is permitted to amend these General Terms and Conditions from time to time without notice. Apart from the General Terms and Conditions, any applicable and publicized rules, promotional conditions, guidelines and provisions pertaining to the services also apply to you and the Provider upon the use of the Services (as defined herein) of the Provider. All those guidelines, rules, promotional conditions and provisions will be considered an inextricable part of these General Terms and Conditions. By availing yourself to use the Services of the Provider, you agree to be bound by these General Terms and Conditions and the guidelines, rules and promotional conditions."
                      />
                    </p>
                  </Col>
            </Row>
          </Container>
        </section>
      );
  }
}

export default Terms;



// WEBPACK FOOTER //
// ./src/components/Terms/Terms.js